import toastMessageServiceSingleton from './toast-message.service';

import { Environment } from 'src/Environment';

const DEFAULT_ERROR_MESSAGE =
  "Uh oh! We're experiencing technical difficulties, but we're working on it. Please try again later.";

const baseUrl = (() => {
  let baseUrl = (Environment.current?.apiHost || '') + (Environment.current?.apiBase || '');
  if (!baseUrl.endsWith('/')) {
    baseUrl = baseUrl + '/';
  }
  return baseUrl;
})();

export async function request(
  url,
  options = { fetchOptions: {} },
  baseURLOverwrite,
  tealiumErrorLogger,
  showToastOnError = true,
  suppressTealiumEventOnError = false,
) {
  let requestBaseUrl = baseUrl;
  if (!!baseURLOverwrite) {
    requestBaseUrl = !baseURLOverwrite.endsWith('/') ? baseURLOverwrite + '/' : baseURLOverwrite;
  }

  options.fetchOptions = options.fetchOptions || {};
  let { fetchOptions } = options;
  fetchOptions.method = fetchOptions.method || 'GET';
  fetchOptions.headers = fetchOptions.headers || {};
  fetchOptions.headers.Accept = fetchOptions.headers.Accept || 'application/json';
  fetchOptions.headers['Content-Type'] = fetchOptions.headers['Content-Type'] || 'application/json';

  if (fetchOptions.headers['Content-Type'] === 'multipart/form-data') {
    // server doesn't like these set for form-data
    delete fetchOptions.headers['Content-Type'];
    delete fetchOptions.headers['Accept'];
  }

  if (url && url.startsWith('/')) {
    url = url.substr(1);
  }

  const fullUrl = `${requestBaseUrl}${url}`;

  try {
    const res = await fetch(fullUrl, fetchOptions);
    const body = res.status === 204 ? {} : await res.json();
    const result = body?.result || body; /* SF */

    if (result && res.status >= 400) {
      let message = DEFAULT_ERROR_MESSAGE;

      // TODO: Add logic to logout if user session invalid - requires backend change

      // TR
      if (result.message) {
        message = result.message;
      }
      // LLL
      else if (result.Message) {
        message = result.Message;
      }
      if (showToastOnError && (!fetchOptions.signal || !fetchOptions.signal.aborted)) {
        toastMessageServiceSingleton.addError(
          message,
          null,
          res.status,
          false,
          null,
          suppressTealiumEventOnError,
        );
      }
      if (tealiumErrorLogger) {
        tealiumErrorLogger(message);
      }
    }

    return { status: res.status, result: result };
  } catch (e) {
    if (showToastOnError && (!fetchOptions.signal || !fetchOptions.signal.aborted)) {
      toastMessageServiceSingleton.addError(
        DEFAULT_ERROR_MESSAGE,
        e,
        'N/A',
        false,
        null,
        suppressTealiumEventOnError,
      );
    }
    if (tealiumErrorLogger) {
      tealiumErrorLogger(DEFAULT_ERROR_MESSAGE);
    }
    return {
      status: 0,
      errorMessage: DEFAULT_ERROR_MESSAGE,
    };
  }
}
